module.exports = global["application_page_testElement"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./test-element.ts");